import React, { useEffect, useState } from "react";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader.jsx";
import { BeforeLoginHeader } from "../../../stories/BeforeLoginHeader/BeforeLoginHeader.jsx";
import { Input } from "../../../stories/Input/Input.jsx";
import { Row, Col, Container } from "react-bootstrap";
import classes from "./PageNotFound.module.css";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import { Small404, Large404, logoColor } from "../../../constant/imagePath";
import { Button } from "../../../stories/Button/Button.jsx";
import { useHistory } from "react-router-dom";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook.js";
import PageNotFoundMobile from "./PageNotFoundMobile.js";
import { useSelector } from "react-redux";

function PageNotFoundDesktop() {
  const history = useHistory();
  const { isLogin } = useSelector((state) => state.authReducer);
  return (
    <div
      className={classes.pageNotFound}
      style={{ backgroundColor: Colors.mainShadeOfSolitude }}
    >
      <Container fluid className="">
        {isLogin ? (
          <div className={classes.header}>
            <AfterLoginHeader />
          </div>
        ) : (
          <BeforeLoginHeader
            icon={logoColor}
            customStyle={{ maxWidth: 'calc(100% - 32px)' }}
          />
        )}
        <Row className="">
          <Col md={12}>
            <div className={classes.mainContent}>
              <img src={Small404} />
              <h3 style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}>
                Looks like you are lost
              </h3>
              <p
                className={classes.pageDoesNotExist}
                style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
              >
                The page you are looking for does not exist.
              </p>
            </div>
          </Col>
          <Col md={12}>
            <div className={classes.btns}>
              {/* <Button
                label={"Start the game"}
                size={"Large"}
                customStyle={{
                  maxWidth: "max-content",
                  padding: "12px 32px 12px 32px",
                }}
              /> */}
              <Button
                label={"Back to home"}
                primary={true}
                onClick={() => history.push("/")}
                size={"Large"}
                customStyle={{
                  maxWidth: "max-content",
                  marginLeft: "16px",
                  padding: "12px 32px 12px 32px",
                }}
              />
            </div>
          </Col>
          {/* Bottom Line */}

          {/* <Col
            md={12}
            className={classes.gameDetails}
            style={{ backgroundColor: Colors.neutralShadesOfNero }}
          >
            <div className={classes.box}>
              <p style={{ ...Fonts.h5, color: Colors.white }}>
                Your Score:{" "}
                <span style={{ ...Fonts.h5, color: Colors.mainShadeOfRed }}>
                  0
                </span>{" "}
              </p>
              <span
                className={classes.break}
                style={{ backgroundColor: Colors.white }}
              />
              <p style={{ ...Fonts.h5, color: Colors.white }}>
                Lifes:{" "}
                <span style={{ ...Fonts.h5, color: Colors.mainShadeOfRed }}>
                  0
                </span>{" "}
              </p>
            </div>
          </Col> */}
        </Row>
      </Container>
    </div>
  );
}

export default function PageNotFound() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, []);
  return isMobile ? <PageNotFoundMobile /> : <PageNotFoundDesktop />;
}
